import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import type { ListingProduct } from 'src/generated/graphql';

interface SearchBoostProductDetailsProps {
  searchBoostProduct: ListingProduct;
}

export const SearchBoostProductDetails = (
  props: SearchBoostProductDetailsProps,
) => (
  <Card data={{ testid: 'search-boost-product-details' }}>
    <Stack space="large">
      <Heading level="4" component="h3">
        Purchase Search Boost add-on
      </Heading>

      <Stack space="medium">
        <Text weight="strong">
          Reach more buyers with better ad visibility:
        </Text>

        <List type="icon" icon={<IconTick tone="positive" />}>
          {[
            'Feature at the top of search results for the same industry and location',
            'Feature on the SEEK Business homepage',
            'Benefit from double the amount of ad views (compared to similar listings in the organic search results)',
            'Your ad remains boosted for the life of your ad',
          ].map((feature, i) => (
            <Text key={i}>{feature}</Text>
          ))}
        </List>
      </Stack>

      <Text
        size="large"
        data={{ testid: 'search-boost-product-details-price' }}
      >
        ${props.searchBoostProduct.cost / 100} + GST
      </Text>
    </Stack>
  </Card>
);
